<div class="esf-accordion__trigger" [class.-is-open]="isPanelOpened" (click)="panelTriggerClick($event)">
  <h4 class="esf-heading esf-heading--low-level esf-action-heading esf-action-heading--low-level">
    <span class="esf-action-heading__text">{{ accordionHeading }}</span>
    <span class="esf-action-heading__actions">
      <span class="esf-action-heading__action">
        <app-spinner [name]="spinnerName" [autoRefresh]="true"></app-spinner>
        <button *ngIf="actionButtonIcon && actionButtonTooltip"
                class="esf-button esf-button--simple"
                [disabled]="actionButtonIsDisabled"
                (click)="actionButtonClick();$event.stopPropagation();"
                [edsTooltip]="actionButtonTooltip">
          <svg class="esf-icon esf-button__icon" width="18" height="18">
            <use [attr.xlink:href]="actionButtonIcon"></use>
          </svg>
          <span class="esf-button__icon-text"></span>
        </button>

      </span>
    </span>
  </h4>
</div>
<div class="esf-accordion__target -is-open" [hidden]="!isPanelOpened">
  <div class="esf-info-tile esf-info-tile--full-width">
    <div class="esf-info-tile__content">
      <ng-content>

      </ng-content>
      <table class="esf-table"
             *ngIf="data?.length && rowClickEvent.observed"
             app-table
             [limitResults]="limitDisplayResults"
             [actionButtons]="actionButtons"
             [columns]="columns"
             [keys]="keys"
             [data]="data"
             (rowButtonClickEvent)="rowButtonClick($event)"
             (rowClickEvent)="rowClick($event)">
      </table>

      <table class="esf-table"
             *ngIf="data?.length && !rowClickEvent.observed"
             app-table
             [limitResults]="limitDisplayResults"
             [actionButtons]="actionButtons"
             [columns]="columns"
             [keys]="keys"
             [data]="data"
             (rowButtonClickEvent)="rowButtonClick($event)">
      </table>

      <section class="esf-empty-state flex-empty-state"
               *ngIf="!data?.length"
               app-empty-state
               [emptyStateIcon]="emptyStateIcon"
               [emptyStateText]="emptyStateText"
               [emptyStateButtonText]="emptyStateButtonText"
               (actionButtonClickEvent)="actionButtonClick()">
      </section>
      <ng-content select="[bottom]">

      </ng-content>
    </div>

    <ng-container *ngIf="showAllLink !== null && totalData">
      <div class="esf-info-tile__show-all" *ngIf="totalData >= limitDisplayResults">
        <button class="esf-button esf-button--simple" [routerLink]="showAllLink">
          <span class="esf-button__icon-text-right-12" i18n="Action button@@general.button.showAll">Show all</span>
          <svg class="esf-icon esf-button__icon esf-button__icon-right" width="12" height="12">
            <use xlink:href="#esf-icon-arrow-right"></use>
          </svg>
        </button>
      </div>
    </ng-container>

  </div>
</div>
